import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useSeo } from '@/hooks/useSeo';
import { siteInfo } from '@/mocks/site';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: `页面未找到｜${siteInfo.name}`,
    description: '你访问的页面不存在或已被调整,可以回到首页继续浏览私拍吃瓜名场面与抓拍整理。',
    keywords: '页面未找到,私拍吃瓜名场面',
    path: location.pathname,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '页面未找到',
      url: `${siteInfo.domain}${location.pathname}`,
      inLanguage: 'zh-CN',
    },
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-md">
          <p className="font-heading text-6xl md:text-7xl text-background-300">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">这个页面不存在</h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的地址是 <span className="text-foreground-800">{location.pathname}</span>
            ,它可能已经被调整。回到首页或者去图鉴里继续翻名场面吧。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-5 py-2.5 rounded-md text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              回到首页
            </Link>
            <Link
              to="/moments"
              className="px-5 py-2.5 rounded-md text-sm whitespace-nowrap border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
            >
              名场面图鉴
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}